import React, { PureComponent } from 'react';
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

export default (getFilters, key = 'materials') => WrappedComponent => class WithQuery extends PureComponent {
  render() {
    const filters = getFilters(this.props)

    return (
      <Query
        variables={filters}
        query={gql`
          query Materials($category: String, $product: String) {
            materials(
              first: 999
              where: {
                materialQuery: {
                  category: $category,
                  product: $product
                }
              }
            ) {
              nodes {
                id
                title
                category
                product
                label
                thumbnail {
                  sourceUrl
                }
                file {
                  sourceUrl
                  mimeType
                }
              }
            }
          }
        `}
      >
        {({ loading, error, data }) => (
          <div>
            {!error &&
              <WrappedComponent
                {...this.props}
                {...{
                  [`${key}Loading`]: loading,
                  [key]: !loading ? data && data['materials'] : undefined
                }}
              />
            }
            {error && <h1>Error: {error.message}</h1>}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/withMaterials.js